import React, { useState, useEffect } from 'react'
import { Form, Formik } from 'formik'
import Button from '../common/Button'
import { required } from '../../utils/validators'
import Input from '../common/Input'

export function AnimalRecordForm({ onSubmit, initialValues, onCancel }) {
    const [imagePreviews, setImagePreviews] = useState([])
    const [existingImages, setExistingImages] = useState([])

    useEffect(() => {
        // Set existing images from initialValues
        if (initialValues?.images && Array.isArray(initialValues.images)) {
            setExistingImages(initialValues.images)
        }
    }, [initialValues])

    const handleImageChange = (event, setFieldValue) => {
        const files = Array.from(event.target.files)
        setFieldValue('newImages', files)

        // Create preview URLs for new images
        const previews = files.map((file) => URL.createObjectURL(file))
        setImagePreviews(previews)
    }

    const removeExistingImage = (imageId) => {
        setExistingImages(existingImages.filter((img) => img.id !== imageId))
    }

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                weight: '',
                health_status: '',
                notes: '',
                record_date: new Date().toISOString().split('T')[0],
                images: [],
                newImages: [],
                ...initialValues
            }}
        >
            {({ setFieldValue }) => (
                <Form>
                    <Input
                        name="weight"
                        type="number"
                        step="0.01"
                        label="Вазн (кг)"
                        placeholder="Масалан: 450.5"
                    />

                    {/* <Input
                        name="health_status"
                        label="Соғлиқ ҳолати"
                        placeholder="Масалан: Яхши, касал, даволанмоқда..."
                    /> */}

                    <Input
                        name="record_date"
                        type="date"
                        label="Тўплам санаси"
                        validate={required}
                    />

                    <Input
                        name="notes"
                        label="Изоҳ"
                        placeholder="Қўшимча маълумот"
                    />

                    <div className="field">
                        <label className="label">
                            Расмлар
                            <span className="has-text-grey-light is-size-7"> (бир нечта танлаш мумкин)</span>
                        </label>

                        {/* Existing images */}
                        {existingImages.length > 0 && (
                            <div className="mb-3">
                                <p className="has-text-weight-semibold mb-2 is-size-7">
                                    Мавжуд расмлар ({existingImages.length}):
                                </p>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {existingImages.map((img) => (
                                        <div key={img.id} style={{ position: 'relative' }}>
                                            <img
                                                src={img.image}
                                                alt={img.caption || 'Расм'}
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    objectFit: 'cover',
                                                    borderRadius: '4px',
                                                    border: '2px solid #48c774'
                                                }}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeExistingImage(img.id)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '-8px',
                                                    right: '-8px',
                                                    background: '#f14668',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '50%',
                                                    width: '24px',
                                                    height: '24px',
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '16px',
                                                    fontWeight: 'bold'
                                                }}
                                                title="Ўчириш"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Upload new images */}
                        <div className="control">
                            <div className="file has-name is-fullwidth">
                                <label className="file-label">
                                    <input
                                        className="file-input"
                                        type="file"
                                        multiple
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(e, setFieldValue)}
                                    />
                                    <span className="file-cta">
                                        <span className="file-icon">
                                            <ion-icon name="images-outline" />
                                        </span>
                                        <span className="file-label">
                                            {existingImages.length > 0 ? 'Янги расмлар қўшиш...' : 'Расмларни танланг...'}
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                        <p className="help is-info">
                            <ion-icon name="information-circle-outline" style={{ verticalAlign: 'middle' }} />
                            {' '}Ctrl (Windows) ёки Cmd (Mac) тугмасини босиб, бир нечта расм танланг
                        </p>

                        {/* New images preview */}
                        {imagePreviews.length > 0 && (
                            <div className="mt-3">
                                <p className="has-text-weight-semibold mb-2 is-size-7 has-text-link">
                                    Янги қўшилаётган расмлар ({imagePreviews.length}):
                                </p>
                                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                                    {imagePreviews.map((preview) => (
                                        <img
                                            key={preview}
                                            src={preview}
                                            alt="Preview"
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                objectFit: 'cover',
                                                borderRadius: '4px',
                                                border: '2px solid #3273dc'
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="is-pulled-right mt-4">
                        {onCancel && (
                            <>
                                <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                                &nbsp;&nbsp;
                            </>
                        )}
                        <Button text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                    </div>
                </Form>
            )}
        </Formik>
    )
}
